import { Injectable, Component } from '@angular/core';
import { ToastController, PopoverController, NavParams, AlertController } from '@ionic/angular';
import { LoadingController } from '@ionic/angular'; 

@Injectable({
  providedIn: 'root'
})
export class AlertService {

  
  constructor(public toast: ToastController, public alertCtrl:AlertController, 
    public popover: PopoverController, public loading: LoadingController) 
  { 

  }

  async showLoading(msg?,duration?) {
    const loading = await this.loading.create({
      //cssClass: 'my-custom-class',
      message: (msg)?msg:'Please wait...',
      duration: (duration)?duration:0,
      spinner: 'crescent'
    });
    await loading.present();
  }

  async hideLoading()
  {
    this.loading.dismiss()
  }

  async presentConfirm(header: any,message: any,cancelText: any,okText: any): Promise<any> {
    return new Promise(async (resolve) => {
      const alert = await this.alertCtrl.create({
        header: header,
        message: message,
        buttons: [
          {
            text: cancelText,
            role: 'cancel',
            cssClass: 'secondary',
            handler: (cancel) => {
              resolve('cancel');
            }
          }, {
            text: okText,
            handler: (ok) => {
              resolve('ok');
            }
          }
        ]
      });
      alert.present();
    });
  }

  async alertMessagePrompt(title:string,message:string) {
	let choice;
    const alert = await this.alertCtrl.create({
      header: title,
      message: message,
        buttons: [
            {
                text: 'Yes',
                handler: () => {
                    alert.dismiss(true);
                    return false;
                }
            }, {
                text: 'No',
                handler: () => {
                    alert.dismiss(false);
                    return false;
                }
            }
        ]
    });

	await alert.present();
	await alert.onDidDismiss().then((data) => {
        choice = data
    })	

	return choice;
  }

  async alertMessage(title:string,message:string) 
  {
    const alert = await this.alertCtrl.create({
      header: title,
      message: message,
      buttons: ['OK']
    });

    await alert.present();
  }

  async alert(title,subtitle,message) 
  {
    const alert = await this.alertCtrl.create({
//      cssClass: 'my-custom-class',
      header: title,
      subHeader: subtitle,
      message: message,
      buttons: ['OK']
    });

    await alert.present();
  }

  async popupToast(string,duration) {
    
    const t = await this.toast.create({
      message: string,
      duration: (duration>0)?duration:30000,
      position: 'top',
    });
    t.present();
  
  }

  async popup(ev,colour,text)
  {
    let popover = await this.popover.create({component:MyPopover, mode: "ios", event: ev, cssClass:"jv-popover"+colour, componentProps:{text: text, colour:colour}});
    popover.onDidDismiss().then(data => {
      if (data && data.data) {
      }
     });
    popover.present();
  }
  
}


@Component({
    selector: 'mypopover',
    styles: ['p {color: #222; padding-left: 0.5rem;padding-right: 0.5rem;text-align:center;font-style: italic;font-weight: 500;font-size: 0.9rem;}'],
    template: `
    <p [style.--background]="(colour)?colour:'#222'">{{text}}</p>
  `,
    standalone: false
})
export class MyPopover {

  text: string;
  colour: string = '#222';

  constructor(public popoverCtrl: PopoverController, private navParams: NavParams) {
   
    this.text = this.navParams.get('text');
    this.colour = this.navParams.get('colour');
  }

  async close(name) {
    await this.popoverCtrl.dismiss(name);
  }
}
